/* Package JSON Import will be here */
import React from "react";
import { Icon, Header, Segment, Table, Pagination, Button, Modal, Form, Input, Search, Confirm } from 'semantic-ui-react';
/* Package JSON Import will be here */

/* Project Import will be here */
import Layout from "../../comman/Layout/Layout";
import { Constants } from '../../../src/config/appConstants';
// import './divisions.css';
import "../../comman/Layout/Layout.css";
import "../../assets/styles/styles.css";
import "./equipmentList.css";
import NoResultFound from "../sharedComponent/noResultFound";
/* Project Import will be here */

const EquipmentListComponent = props => {
    const myiconstyle = { color: "#f18f40", margin: "5px", cursor: "pointer" };
    return (

        <Layout>
            <Segment className="header-section">
                <Header as="h3">
                    <span className="iconify myiconstyle_1" data-icon="material-symbols:forklift-outline" data-inline="false" ></span>
                    <span>Equipment List</span>
                </Header>
                <i aria-hidden="true"
                    onClick={() => { props.onOpenModel({ data: {} }); }}
                    style={myiconstyle} className="plus circle icon">
                </i>
            </Segment>
            <Table className="ui celled table">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell className="tableCell"></Table.HeaderCell>
                        <Table.HeaderCell className="text-left">
                            Equipment List
                            <Search className="theader" onSearchChange={props.onEquipmentListSearch}
                                placeholder={Constants.SEARCH_PLACEHOLDER} />
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {props.equipmentList.equipmentListDataList && props.equipmentList.equipmentListDataList.length > 0 ? props.equipmentList.equipmentListDataList.map(({ displayText, id }) => (
                        <Table.Row style={{ verticalAlign: 'baseline' }}>
                            <Table.Cell textAlign="center" className="tableCell">
                                <div className="forcastIcon">
                                    <Icon className="myiconstyle" edit name='trash alternate outline'
                                        onClick={() => { props.onDeleteEquipmentList({ equipmentListId: id }); }}
                                    />
                                    <Icon className="myiconstyle" edit name='edit pencil'
                                        onClick={() => {
                                            props.onOpenModel({ equipmentListId: id });
                                        }}
                                    />
                                </div>
                            </Table.Cell>
                            <Table.Cell>{displayText}</Table.Cell>
                        </Table.Row>
                    )) :
                        <Table.Row>
                            <Table.Cell colSpan='2'>
                                <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                            </Table.Cell>
                        </Table.Row>
                    }
                </Table.Body>
            </Table>

            <Modal closeIcon
                open={props.equipmentList.isOpenModel}
                closeOnDimmerClick={false}
                onClose={() => { props.onCloseModel(); }}
                size='tiny'
            >
                <Modal.Header>{(props.equipmentList.selectedValue && props.equipmentList.selectedValue.equipmentListId > 0) ? "Edit Equipment List" : "Add Equipment List"}</Modal.Header>
                <Modal.Content style={{ overflow: 'visible' }}>
                    <Form>
                        {/* <Form.Group inline widths='equal'> */}

                        {/* <label>Equipment List:</label> */}
                        <Form.Field required>
                            <label>Equipment List:</label>
                            <Input
                                placeholder='Enter Equipment'
                                maxLength={50}
                                value={props.equipmentList.selectedValue ? props.equipmentList.selectedValue.equipmentListName : ""}
                                onChange={(e) => props.handleEquipmentListChange(e, { name: "equipmentList", value: e.target.value })}
                            />
                        </Form.Field>
                        {/* </Form.Group> */}
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    {props.equipmentList.isEditEquipmentList ?
                        <Button disabled={props.equipmentList.isSetButtonDisabled} type="submit" primary onClick={() => props.onSaveEquipmentList(props.equipmentList.selectedValue.equipmentListId)}> Update </Button> :
                        <Button disabled={props.equipmentList.isSetButtonDisabled} type="submit" primary onClick={() => props.onSaveEquipmentList()}> Save </Button>
                    }
                    <Button secondary onClick={() => props.onCloseModel()} > Back </Button>
                </Modal.Actions>
            </Modal>
            <Confirm
                closeIcon
                open={props.equipmentList.isDeleteConfiram}
                content="Are you sure? Do you want to delete this Equipment List?"
                header='Confirmation'
                size="tiny"
                onCancel={() => { props.onCancelDelete(); }}
                onConfirm={() => { props.onConfirmDelete(); }}
            />
            {props.equipmentList.equipmentListDataList && props.equipmentList.equipmentListDataList.length > 0 &&
                <Pagination floated="right"
                    activePage={props.equipmentList.pagination.activePage}
                    onPageChange={props.onPageChange}
                    ellipsisItem={null}
                    firstItem={null}
                    lastItem={null}
                    totalPages={props.equipmentList.pagination.totalCount} />
            }
        </Layout >
    );
}

export default EquipmentListComponent;

EquipmentListComponent.displayName = "EquipmentListComponent";